<template>
    <div class="planceindex spackage">
        <div class="blod">基本数据</div>
        <div class="key-data">
            <div class="box box-shadow bgc" v-for="(item,index) in keyData" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.tooltip" placement="top-start">
                    <i class="el-icon-warning"></i>
                </el-tooltip>
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                </div>
            </div>
        </div>

        <div class="data-table">
            <div class="trendTitle">
                <el-tabs v-model="activeTitleName" class="trendName">
                    <el-tab-pane label="基础数据" name="first"></el-tab-pane>
                </el-tabs>
                <el-tabs v-model="activeName" @tab-click="handleClick" class="tablist">
                    <el-tab-pane label="今日" name='0'></el-tab-pane>
                    <el-tab-pane label="昨日" name='1'></el-tab-pane>
                    <el-tab-pane label="近7日" name='6'></el-tab-pane>
                    <el-tab-pane label="近30日" name='29'></el-tab-pane>
                    <el-tab-pane name="zdy">
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleClick"></el-date-picker>
                          </div>
                    </span>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
        </div>
    </div>
</template>

<script>
    import {getBasicData,getAboveData} from 'api/communityApi'
    import fecha from 'element-ui/src/utils/date';
    import {mapGetters, mapActions} from 'vuex'
    import LineReport from 'base/echarts/lineReportStar'

    export default {
        name: "baseData",
        data() {
            return {
                innerid: this.$route.query.innerid,
                keyData: [
                    {'title': '访问量PV', total: 0, type: true, tooltip: '访问量PV数量'},
                    {'title': '独立访客UV', total: 0, type: true, tooltip: '独立访客UV数量'},
                    {'title': 'IP数', total: 0, type: false, tooltip: 'IP数量'}
                ],
                param: {
                    date: [],
                    status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
                },
                activeTitleName: 'first',
                activeName: '0',
                lineDatas: {id: 'index', subText: '', xdata: [], data: []},
                tpm: {
                    beginTime: '',
                    endTime: ''
                }
            }
        },
        watch: {
            'param.date': {
                handler(newV, oldV) {
                    let tmp = {
                        status: this.param.status,
                        begintime: this._time(newV[0]),
                        endtime: this._time(newV[1])
                    };
                    this._getIndexData(tmp)
                }
            },
            deep: true
        },
        methods: {
            // 获取顶部数据
            getTopData(){
                this.setLoading(true);
                getAboveData({
                    data: {
                        starinnerid: this.innerid,
                    },
                    success: data => {
                        this.setLoading(false);
                        console.log(data);
                        // 访客量
                        this.keyData[0].total = data.data.startviewsum;
                        // 昨日帖子
                        this.keyData[1].total = data.data.startvisitclient;
                        // 访客ip
                        this.keyData[2].total = data.data.startip;
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg);
                    }
                })
            },
            handleClick(tab, event) {
                if (tab.name !== 'zdy') {
                    if (event.srcElement.className !== "el-tabs__item is-top is-active") {
                        const date = new Date(),
                            tpm = this.tpm;
                        this.param.type = tab.type;

                        if (tab.name === '0') {
                            tpm.beginTime = this._time(date.getTime())
                        } else {
                            tpm.beginTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        }

                        if (tab.name === '1') {
                            tpm.endTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        } else {
                            tpm.endTime = this._time(date.getTime())
                        }
                        this._getIndexData(tpm)
                    }
                }
            },
            _getIndexData(tmp) {
                this.setLoading(true);
                getBasicData({
                    data: {
                        starinnerid: this.innerid,
                        beginTime: tmp.beginTime||tmp.begintime,
                        endTime: tmp.endTime||tmp.endtime
                    },
                    success: data => {
                        this.setLoading(false);
                        if (data.code === '000') {
                            // 数据表
                            this.lineDatas.xdata = data.data[0].xdatalist;
                            this.lineDatas.data = [];
                            this.lineDatas.data.push({
                                title: 'ip数',
                                color: '#5D7092',
                                list: data.data[0].startipYdata
                            });
                            this.lineDatas.data.push({
                                title: '访客量',
                                color: '#5B8FF9',
                                list: data.data[0].startviewYdata
                            });
                            this.lineDatas.data.push({
                                title: '独立访客数',
                                color: '#5AD8A6',
                                list: data.data[0].startvisitclientYdata
                            });
                            this.lineDatas.legend = {
                                left: 'center',
                                data: ['ip数', '访客量','独立访客数']
                            };
                            // this.lineDatas.subText = '贴子数/资料数';
                            this.$nextTick(() => {
                                this.keyData = this.keyData
                                this.lineDatas = this.lineDatas
                            })
                        }
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg);
                    }
                })
            },
            _time(time) {
                const temp = new Date(time);
                return fecha.format(temp, 'yyyy-MM-dd');
            },
            indexInfo() {
                const date = new Date(),
                    tpm = {
                        beginTime: this._time(date.getTime()),
                        endTime: this._time(date.getTime())
                    };
                this._getIndexData(tpm)
            },
            ...mapActions(['setLoading'])
        },
        mounted() {
            this.indexInfo();
            this.getTopData()
        },
        components: {
            LineReport
        },
        computed: {
            ...mapGetters(['loading'])
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .planceindex {
        .bold {
            font-weight: bold;
        }
        .trendTitle {
            margin-top: 24px;
            margin-bottom: 24px;
            /*padding-top: 4px;*/
            height: 43px;
            border-bottom: solid 2px #E4E7ED;
            padding: 4px 30px 0 30px;
            .trendName {
                flex-grow: 1;
            }
            .el-tabs__item {
                height: 45px;
            }
            .trendName,
            .tablist {
                float: left;
            }
            .tablist {
                float: right;
                /*width: calc(100% - 115.45px);*/
                .el-tabs__nav {
                    float: right;
                }
                .el-tabs__active-bar{
                    background: none!important;
                }
            }
            .el-tabs__nav {
                margin-left: 20px;
                margin-right: 20px;
            }
            .el-range-editor.el-input__inner {
                padding: 3px 5px;
            }
            .el-range-editor.el-input__inner {
                height: 32px;
                line-height: 32px;
            }
            .el-date-editor .el-range__icon {
                line-height: 26px;
            }
            .el-date-editor .el-range-separator {
                line-height: 26px;
            }
        }
        .key-data {
            display: block;
            margin-top: 14px;
            width: 100%;
            .item {
                float: right;
                width: auto;
                color: #C0C4CC;
                font-size: 14px;
                text-align: right;
                box-sizing: border-box;
            }
            .summary {
                clear: both;
                margin-left: 20px;
                margin-top: 6px;
                font-size: 14px;
            }
            .content {
                .num {
                    float: left;
                    margin-left: 20px;
                    margin-top: 12px;
                    font-size: 30px;
                    color: #303133;
                }
                .icon {
                    float: right;
                    margin-top: 12px;
                    margin-right: 10px;
                    min-width: 34px;
                    min-height: 34px;
                    width: 34px;
                    height: 34px;
                }
                .icon.icon_index_1 {
                    background: url("../../common/images/planetCommunity/index-1.png") center no-repeat;
                    background-size: 34px;
                }
                .icon.icon_index_2 {
                    background: url("../../common/images/planetCommunity/index-2.png") center no-repeat;
                    background-size: 34px;
                }
            }

            .box {
                padding: 10px;
                display: inline-block;
                margin-left: 40px;
                width: calc((100% - 80px) / 3);
                height: 120px;
                box-sizing: border-box;
            }
            .box:nth-child(1) {
                margin-left: 0;
            }
            .box:nth-child(1) .content .num {
                color: #409EFF;
            }
        }
        .data-table {
            margin-top: 20px;
            padding: 0 0;
            padding-bottom: 30px;
            box-sizing: border-box;
            background: #fff;

            .lineDatas {
                #index div {
                    width: 100px;
                }
                canvas {
                    width: 100%;
                }
            }
        }
    }

    /*样式更改*/
    .planceindex .trendTitle .el-tabs__nav {
        margin-left: 0;
        margin-right: 0;
    }
</style>
